// extracted by mini-css-extract-plugin
export default {"rating":"Xz-z","numberOfStars":"Yz-z","count":"Zz-z","barGraphSpacing":"_z-z","barGraph":"aA-z"};